export default __webpack_public_path__ + "static/media/Pre-Dispatch-Newspaper-publication-for-AGM.7d1bafae.pdf";